import { useState } from 'react';

import constate from 'constate';

export type Brand = {
    sidebarBackgroundColor?: string;
    sidebarForegroundColor?: string;
    buttonBackgroundColor?: string;
    buttonForegroundColor?: string;
    logoUrl?: string;
};

function useBrandPreview() {
    const [brandPreview, setBrandPreview] = useState<Brand | null>();

    function clearBrandingPreview() {
        setBrandPreview(null);
    }

    return { brandPreview, setBrandPreview, clearBrandingPreview };
}

const [BrandPreviewContextProvider, useBrandPreviewContext] = constate(useBrandPreview);

export { BrandPreviewContextProvider, useBrandPreviewContext };
